module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACbSURBVHgB7dUxEoQgDAXQH3cL7dgbeIS123KPxtEs7fQGcgQKCysxQcaxswljw6uAIjOQ/AEoblCwvxZhG3lpoMuBmq4CKpOhuGiB1ZCs4i3igaZ6Itt7FI9LTf4b6ThU1V6anDMHXLL5cA5WHiXKME7BnzmI2yMLio4nQvG4Sw6WL1S9HdnBpRyEGTnQ1qUc8OegTnLwKmN6bwfVRTNVBU++bAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/mb2.png
// module id = f0O+
// module chunks = 25